<template lang="pug">
  v-container.results.d-flex.flex-column(style="height:100%")
    div.d-flex.align-center.flex-wrap
      Breadcrumbs.pl-0
      v-form.flex-grow-1.d-flex
        v-text-field(
          clearable
          outlined
          placeholder="Search Open Data Portal"
          prepend-inner-icon="search"
          v-model="term"
          @change="$router.push({ name: 'results', query: { term: term } }).catch(()=>{})"
          hide-details
        )
        v-select.ml-4(
          v-model="orderBy"
          outlined
          hide-details
          :items="orderByOptions"
          label="Order by"
          @change="search"
          style="max-width:160px"
        )
    .d-flex.align-center
      v-btn(text color="primary" :to="{name: 'advsearch'}").mb-2.flex-grow-1 Switch to Advanced Search
      v-tooltip(bottom dark max-width=300)
        template(v-slot:activator="{on}")
          div(v-on="on")
            v-checkbox(v-model="showProtected" label="Show Internal Use Datasets" @change="search").flex-shrink-1
        span Internal use datasets are designed to support County backend processes, may include personal information about County employees and, accordingly, are not made publicly available.
    v-card(outlined)
      div(v-for="(result, index) in data" :key="result.id")
        Datacard(
          :title="result.title"
          :description="result.description"
          :number-of-records="result.number_of_records"
          :s3-details="result.s3_details"
          :url="result.data_source"
          :ext-url="result.external_url"
          :dataset-id="result.id"
          :collection-id="result.collection ? result.collection.id : null"
          :collection-title="result.collection ? result.collection.title : null"
          :to="{name:'dataset',params:{id:result.id}}"
          rows="2"
          show-nav
          outlined
          showCollection
          hoverDetails
          :isProtected="result.visibility=='protected'"
        ).ma-4
        hr(v-if="index < data.length-1").d-none
    v-spacer.flex-grow-1
    div.d-flex.justify-space-between.align-center.mt-3
      v-btn.flex-shrink-1(width=150 color="primary" :disabled="atMinPage" @click="prevPage")
        v-icon(:left="$vuetify.breakpoint.smAndUp") mdi-arrow-left
        span.d-none.d-sm-inline Previous
      p.text-center.my-auto.mx-4.flex-shrink-0 Page {{page+1}} of {{maxPage+1}}
      v-btn.flex-shrink-1(width=150 color="primary" :disabled="atMaxPage" @click="nextPage")
        span.d-none.d-sm-inline Next
        v-icon(:right="$vuetify.breakpoint.smAndUp") mdi-arrow-right
</template>

<script>
import Datacard from '@/components/Datacard.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
  data: () => ({
    orderByOptions: [
      { text: "Relevance", value: "_score" },
      { text: "Title", value: "title.raw" },
      { text: "Publish Date", value: "publish_date" },
      { text: "Last Update", value: "s3_details.LastModified" }
    ]
  }),
  components: {
    Datacard,
    Breadcrumbs
  },
  computed: {
    loading () { return this.$store.state.loading },
    term: {
      get() { return this.$store.state.term },
      set(value) { this.$store.commit('set', { term: value }) }
    },
    orderBy: {
      get() { return this.$store.state.orderBy },
      set(value) {
        if(value == '_score') this.$store.commit('set', { orderBy: value, orderByAsc: 'desc'})
        else if(value == 'title.raw') this.$store.commit('set', { orderBy: value, orderByAsc: 'asc'})
        else if(value == 'publish_date') this.$store.commit('set', { orderBy: value, orderByAsc: 'desc'})
        else if(value == 's3_details.LastModified') this.$store.commit('set', { orderBy: value, orderByAsc: 'desc'})
      }
    },
    showProtected: {
      get() { return this.$store.state.showProtected },
      set(value) { this.$store.commit('set', { showProtected: value }) }
    },
    data () { return this.$store.state.data },
    page () { return this.$store.state.page },
    pageSize: {
      get() { return this.$store.state.pageSize },
      set(value) { this.$store.commit('set', { pageSize: value }) }
    },
    resultCount () { return this.$store.state.resultCount },
    atMinPage () { return this.$store.getters.atMinPage },
    atMaxPage () { return this.$store.getters.atMaxPage },
    maxPage () { return this.$store.getters.maxPage }
  },
  methods: {
    updateFromQuery () {
      if(this.$route.query) {
        if(this.term != this.$route.query.term || !this.data.length){
          this.term = this.$route.query.term
          this.search()
        }
      } else if(!this.data) {
        this.search()
      }
    },
    search () {
      if(!this.term && this.orderBy == "_score"){
        this.term = ''
        this.orderBy = "title.raw"
      }
      return this.$store.commit('search')
    },
    nextPage () { return this.$store.commit('nextPage') },
    prevPage () { return this.$store.commit('prevPage') }
  },
  created() {
    this.$store.commit('initSimple')
    this.updateFromQuery()
  },
  watch: {
    $route: function (value) {
      this.term = value.query && value.query.term ? value.query.term : ""
      this.search()
    }
  }
}
</script>